import { useEffect, useState } from "react";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export function DashHeader() {
  const { user, logout } = useAuth();
  const [resend, setResend] = useState(null);

  useEffect(() => { api.get("/resend/domains").then((r) => setResend(r.data)).catch(() => setResend({ connected: false })); }, []);

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="h-7 w-7 rounded-md bg-primary grid place-items-center font-display font-bold text-sm">R</div>
          <span className="font-display font-semibold tracking-tight hidden sm:inline">Sales Leads Redoc</span>
        </div>
        <div className="flex items-center gap-3">
          <span data-testid="resend-status-pill"
            className={`text-xs font-mono px-3 py-1 rounded-full border ${resend?.connected ? "bg-emerald-500/10 text-emerald-700 border-emerald-500/20" : "bg-amber-500/10 text-amber-700 border-amber-500/20"}`}>
            {resend === null ? "Resend…" : resend.connected ? "Resend connected" : "Resend not connected"}
          </span>
          <span className="text-xs text-muted-foreground hidden md:inline font-mono" data-testid="admin-user-email">{user?.email}</span>
          <Button variant="ghost" size="sm" onClick={logout} data-testid="logout-button">
            <LogOut className="h-4 w-4 mr-1.5" />Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
